import { useFetchRefundRequestList } from "../repository/query/fetch-refund-request-list";

type Props = {
	hotelID: string;
};

export const useInitialized = ({ hotelID }: Props) => {
	const { data } = useFetchRefundRequestList({ hotelID });

	return {
		data,
	};
};
